<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="!loading">
      <div>
        <div class="row">
          <b-form-group class="mb-3" label="Áreas de interesse">
            <multiselect
              v-model="dados.areaInteresse"
              placeholder="Selecione"
              :show-labels="false"
              label="ds_area_interesse"
              :options="optionAreaInteresse"
              :close-on-select="true"
              :multiple="true"
              @select="inserirAreaInteresse"
              @remove="removerAreaInteresse"
              track-by="cd_area_interesse"
              :max="2"
            >
              <span slot="maxElements">Limite de 2 Áreas de interesse.</span>
            </multiselect>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="mb-3" label="Regiões de interesse em atuação">
            <multiselect
              v-model="dados.regiaoInteresse"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionRegiaoInteresse"
              label="nm_regiao"
              track-by="nm_regiao"
              :close-on-select="true"
              :multiple="true"
              @select="inserirRegiao"
              @remove="removerRegiao"
            />
            <b-form-checkbox
              id="todasRegioes"
              v-model="dados.todasRegioes"
              name="todasRegioes"
              :value="true"
              :unchecked-value="false"
              @change="montaTodasRegioes"
              plain
            >
              Marcar todas
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="mb-3" label="Ambientes de interesse">
            <multiselect
              v-model="dados.ambienteInteresse"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionAmbienteInteresse"
              :multiple="true"
              label="dsambientetrabalho"
              track-by="sqambientetrabalho"
              @select="incluirAmbiente"
              @remove="removerAmbiente"
              :max="3"
            >
              <span slot="maxElements"
                >Limite de 3 Ambientes de interesse.</span
              >
            </multiselect>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="mb-3" label="Conhecimentos e Habilidades">
            <multiselect
              v-model="dados.conhecimentosHabilidades"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionconhecimentosHabilidades"
              label="ds_habilidade"
              track-by="sq_habilidade"
              :multiple="true"
              @select="incluirPessoaHabilidade"
              @remove="removerPessoaHabilidade"
              :max="5"
            >
              <span slot="maxElements"
                >Limite de 5 Conhecimentos e Habilidades.</span
              >
            </multiselect>
          </b-form-group>
        </div>
        <div class="row">
          <div class="mt-1 d-flex justify-content-between">
            <b-button
              class="mt-1 me-1"
              @click="navegar('ExpProfissional', false)"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-left-circle font-size-15"></i>
            </b-button>
            <b-button
              variant="primary"
              class="mt-1 me-1"
              @click="navegar('idiomas', true)"
              data-tooltip="Próximo"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-right-circle font-size-15"></i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Multiselect from "vue-multiselect";

// const capitalizeString = (str) => {
//   return str
//     .split(" ")
//     .map((word) => {
//       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//     })
//     .join(" ");
// };

export default {
  components: {
    Multiselect,
  },
  async created() {
    try {
      await this.preencheLookup();
      await this.buscarPreenchido();
      this.$emit("carregarNivelPerfil");
    } catch (err) {
      this.$tools.alerta(
        err.response?.data?.message || "Não foi possível carregar as áreas de interesse.",
        "error"
      );
    } finally {
      this.loading = false;
    }
  },
  data() {
    return {
      dados: {
        areaInteresse: "",
        regiaoInteresse: "",
        ambienteInteresse: "",
        conhecimentosHabilidades: "",
        disponivelMudanca: "",
        todasRegioes: "",
      },
      loading: true,
      optionAreaInteresse: [],
      optionRegiaoInteresse: [],
      optionAmbienteInteresse: [],
      optionconhecimentosHabilidades: [],
      camposAreaInteresse: [
        {
          key: "DSAREAINTERESSE",
          label: "Área de interesse",
        },
        {
          key: "options",
          label: "",
        },
      ],
    };
  },
  methods: {
    async preencheLookup() {
      const respostas = await Promise.allSettled([
        this.$http.get("api/profileErp/cargos-profissionais"),
        // A regra de persistência do ERP aceita somente regiões de nível Estado.
        this.$http.get("api/profileErp/regioes?nivelIbge=3&tamanho=200"),
        this.$http.get("api/profileErp/ambientes-trabalho"),
        this.$http.get("api/profileErp/conhecimentos-habilidades"),
      ]);
      const lista = (resultado) => {
        if (resultado.status !== "fulfilled") return [];

        const dados = resultado.value.data;
        return Array.isArray(dados)
          ? dados
          : dados?.Items || dados?.Data?.Items || dados?.data?.Items || dados?.Data || dados?.data || [];
      };
      const [cargos, regioes, ambientes, habilidades] = respostas.map(lista);

      this.optionAreaInteresse = cargos.map((item) => ({
        ...item,
        cd_area_interesse: item.Id || item.id,
        ds_area_interesse: item.Descricao || item.descricao || item.Nome || item.nome || "",
      }));
      this.optionRegiaoInteresse = regioes.map((item) => ({
        ...item,
        sq_regiao: item.Id || item.id,
        nm_regiao: item.Descricao || item.descricao || item.Nome || item.nome || "",
      }));
      this.optionAmbienteInteresse = ambientes.map((item) => ({
        ...item,
        sqambientetrabalho: item.Id || item.id,
        dsambientetrabalho: item.Descricao || item.descricao || item.Nome || item.nome || "",
      }));
      this.optionconhecimentosHabilidades = habilidades.map((item) => ({
        ...item,
        sq_habilidade: item.Id || item.id,
        ds_habilidade: item.Descricao || item.descricao || item.Nome || item.nome || "",
      }));
    },
    async buscarPreenchido() {
      const response = await this.$http.get("api/profileErp/areas-interesse");
      const dados = response.data?.Data || response.data?.data || response.data || {};
      const selecionar = (opcoes, ids) => {
        const selecionados = new Set((ids || []).map(String));
        return opcoes.filter((opcao) => selecionados.has(String(opcao.Id || opcao.id)));
      };

      this.dados.areaInteresse = selecionar(
        this.optionAreaInteresse,
        dados.IdsCargosProfissionais || dados.idsCargosProfissionais
      );
      this.dados.regiaoInteresse = selecionar(
        this.optionRegiaoInteresse,
        dados.IdsRegioesInteresse || dados.idsRegioesInteresse
      );
      this.dados.ambienteInteresse = selecionar(
        this.optionAmbienteInteresse,
        dados.IdsAmbientesTrabalho || dados.idsAmbientesTrabalho
      );
      this.dados.conhecimentosHabilidades = selecionar(
        this.optionconhecimentosHabilidades,
        dados.IdsConhecimentosHabilidades || dados.idsConhecimentosHabilidades
      );
      this.dados.todasRegioes = this.optionRegiaoInteresse.length > 0
        && this.dados.regiaoInteresse.length === this.optionRegiaoInteresse.length;
    },

    navegar(nomeAba, direcao) {
      this.$emit("carregarNivelPerfil");
      this.$emit("navegar", nomeAba, direcao);
    },

    async salvarAreasInteresse() {
      const ids = (itens, campo) => (itens || []).map(item => item[campo] || item.Id || item.id);
      const dados = {
        IdsCargosProfissionais: ids(this.dados.areaInteresse, "cd_area_interesse"),
        IdsRegioesInteresse: ids(this.dados.regiaoInteresse, "sq_regiao"),
        IdsAmbientesTrabalho: ids(this.dados.ambienteInteresse, "sqambientetrabalho"),
        IdsConhecimentosHabilidades: ids(this.dados.conhecimentosHabilidades, "sq_habilidade"),
      };
      try {
        await this.$http.post("api/profileErp/areas-interesse", dados);
      } catch (err) {
        this.$tools.alerta(
          err.response?.data?.message || "Não foi possível salvar as áreas de interesse.",
          "error"
        );
      }
    },

    inserirAreaInteresse() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    removerAreaInteresse() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    inserirRegiao() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    removerRegiao() {
      this.dados.todasRegioes = false;
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    incluirAmbiente() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    removerAmbiente() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    incluirPessoaHabilidade() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    removerPessoaHabilidade() {
      this.$nextTick(() => this.salvarAreasInteresse());
    },

    montaTodasRegioes() {
      if (this.dados.todasRegioes) {
        if (this.dados.regiaoInteresse.length === this.optionRegiaoInteresse.length) {
          this.$tools.alerta(
            "Todos as regiões de interese estão cadastradas",
            "info"
          );
          return;
        }
        this.dados.regiaoInteresse = this.optionRegiaoInteresse;
        this.salvarAreasInteresse();
      }
    },
  },
};
</script>

  <style>
.multiselect__tag {
  background: #41b883 !important;
}
</style>
